<template>
    <div class="Wrapper pos-r mb-2">
        <WText
            tag="label"
            typo="label"
            size="14"
        >
            {{ $t(`entities.creation.labels.${section}`) }}
        </WText>
        <div class="mb-1">
            <WSelect
                :value="''"
                name="newTransform"
                :placeholder="$t(`entities.creation.placeholder.${section}`)"
                :options="optionsFiltered"
                :disabled="isLoading || isFetching"
                @input="handleChange"
            />
        </div>
        <FadeHeightTransitionGroup tag="div">
            <div
                v-for="({ key, label }) in optionsSelected"
                :key="key"
                class="Item"
            >
                <div class="flex row-stretch-center">
                    <WText
                        color="gray"
                        :size="14"
                    >
                        {{ label }}
                    </WText>
                    <WIcon
                        icon="trash"
                        class="RemoveIcon ml-1"
                        @click="removeTransform(key)"
                    />
                </div>
            </div>
        </FadeHeightTransitionGroup>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import {
    Api, apiRequest, rethrowError, notifyError,
} from '@/api'

export default {
    name: 'Options',
    props: {
        value: VueTypes.arrayOf(VueTypes.string),
        section: VueTypes.string.required,
        isLoading: VueTypes.bool.def(false),
    },
    data () {
        return {
            options: undefined,
            isFetching: false,
        }
    },
    computed: {
        optionsFiltered () {
            return (this.options || []).filter(({ key }) => ![...(this.value || [])].includes(key))
        },
        optionsSelected () {
            return (this.options || []).filter(({ key }) => [...(this.value || [])].includes(key))
        },
    },
    mounted () {
        this.getOptions()
    },
    methods: {
        getOptions () {
            this.isFetching = true
            apiRequest(Api().entities[this.section]())
                .then(({ data }) => (this.options = this.normalizeOptions(data)))
                .catch(rethrowError(notifyError()))
                .finally(() => (this.isFetching = false))
        },
        normalizeOptions (data) {
            return (data || []).map(({ key, name }) => ({ key, label: name }))
        },
        handleChange (value) {
            this.$emit('input', [...this.value, value])
        },
        removeTransform (key) {
            this.$emit('input', this.value.filter(value => value !== key))
        },
    },
}
</script>

<style lang="scss" scoped>
.Loader {
    width: 100%;
    max-width: 280px;
    min-height: 50px;
}

.Item {
    width: 100%;

    & + .Item > div {
        margin-top: 8px;
        padding-top: 8px;
        border-top: solid 1px $gray-05;
    }
}

.RemoveIcon {
    margin-right: 13px;
    cursor: pointer;
    opacity: .5;

    &:hover {
        opacity: 1;
    }
}

.WSelect {
    &::v-deep {
        .multiselect__single {
            overflow: hidden;
        }
    }
}
</style>
